module.exports = __webpack_public_path__ + "static/media/burger.6d4fb064.svg";